import React, { useEffect, useState } from "react";
import api from "../../api";
import { useParams, useNavigate } from "react-router-dom";

export default function SupportTicketView() {
  const { id } = useParams();
  const nav = useNavigate();

  const [ticket, setTicket] = useState(null);
  const [reply, setReply] = useState("");

  const loadTicket = async () => {
    const res = await api.get(`/support/admin/ticket/${id}`);
    setTicket(res.data);
  };

  useEffect(() => {
    loadTicket();
  }, [id]);

  const sendReply = async () => {
    if (!reply.trim()) return alert("Reply cannot be empty");

    await api.post(`/support/admin/ticket/${id}/reply`, {
      message: reply.trim()
    });

    setReply("");
    loadTicket();
  };

  const closeTicket = async () => {
    await api.post(`/support/admin/ticket/${id}/close`);
    alert("Ticket closed");
    nav("/admin/support");
  };

  if (!ticket) return <p>Loading...</p>;

  return (
    <div style={{ padding: 30 }}>
      <h2>🎫 {ticket.title}</h2>
      <p><b>Status:</b> {ticket.status}</p>
      <p><b>Priority:</b> {ticket.priority}</p>

      <hr />

      <h3>💬 Conversation</h3>

      {ticket.messages.map((m, i) => (
        <div
          key={i}
          style={{
            background: m.sender === "admin" ? "#e0f2fe" : "#f1f5f9",
            padding: 10,
            marginBottom: 8,
            borderRadius: 6
          }}
        >
          <b>{m.sender}</b>
          <p>{m.message}</p>
        </div>
      ))}

      {ticket.status === "open" && (
        <>
          <textarea
            value={reply}
            onChange={(e) => setReply(e.target.value)}
            rows={4}
            style={{ width: "100%", marginTop: 10 }}
            placeholder="Type your reply..."
          />

          <button onClick={sendReply} style={{ marginTop: 10 }}>
            Send Reply
          </button>

          <button
            onClick={closeTicket}
            style={{ marginLeft: 10, background: "#ef4444", color: "white" }}
          >
            Close Ticket
          </button>
        </>
      )}
    </div>
  );
}
